import {
    VISIBLE_ROOM_SWITCHED,
    VISIBLE_ROOM_CLOSED,
    ROOM_LEAVED,
    ROOM_JOINED,
    ROOM_DESTROYED
} from '../constants/rooms';

import {LOGIN_SUCCESS} from '../constants/general';

const defaultState = {
    all_roomids: [],
    roomid: undefined
};

export default function currentRoom(state = defaultState, action) {
    if (action.type == LOGIN_SUCCESS) {
        return {
            all_roomids: [action.room.roomid],
            roomid: action.room.roomid
        };
    }

    if (action.type == ROOM_LEAVED
        || action.type == ROOM_DESTROYED
        || action.type == VISIBLE_ROOM_CLOSED) {

        if (action.type == ROOM_DESTROYED) {
            // console.log(action);
        }
        let newRoomIds = state.all_roomids.filter(function(rid) {
            return rid != action.roomid;
        });

        if (state.roomid == action.roomid) {
            let newRoomId = "";

            if (newRoomIds.length != 0) {
                newRoomId = newRoomIds[0];
            }

            return {
                all_roomids: newRoomIds,
                roomid: newRoomId
            }
        } else {
            return {
                ...state,
                all_roomids: newRoomIds
            }
        }
    }

    if (action.type == ROOM_JOINED) {
        return {
            ...state,
            all_roomids: [...state.all_roomids, action.roomid]
        }
    }

    if (action.type == VISIBLE_ROOM_SWITCHED) {
        return {
            ...state,
            roomid: action.room.roomid
        }
    }

    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/visibleChatrooms.js